export default __webpack_public_path__ + "static/media/5.caf89365.svg";